import { render } from "./BannerIncrease.vue?vue&type=template&id=e0c8b154&scoped=true"
import script from "./BannerIncrease.vue?vue&type=script&lang=js"
export * from "./BannerIncrease.vue?vue&type=script&lang=js"

import "./BannerIncrease.vue?vue&type=style&index=0&id=e0c8b154&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0c8b154"]])

export default __exports__